<template>
    <div
        class="quay-marker-icon d-inline-flex align-center justify-center"
        :style="{ height: `${size}px`, width: `${size}px`, lineHeight: `${size}px` }"
    >
        <div class="quay-marker-icon__inner d-inline-flex flex-column align-center" :style="{ transform: `scale(${scale})` }">
            <div class="quay-marker-icon__signboard d-flex align-center justify-center" :class="cssClasses">
                <v-icon :icon="icon" :size="iconSize" />
            </div>
            <div class="quay-marker-icon__post"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { VIcon } from 'vuetify/components';

interface Props {
    icon?: string;
    color?: string;
    size?: number | string;
    iconSize?: number | string;
}

const props = withDefaults(defineProps<Props>(), { color: 'blue', size: 24, iconSize: 16 });
const cssClasses = computed(() => [`bg-${props.color}`]);
const scale = computed(() => Number(props.size) / 24);
</script>

<style lang="scss">
.quay-marker-icon {
    &__signboard {
        width: 24px;
        height: 16px;
    }

    &__post {
        width: 4px;
        height: 8px;
        background: linear-gradient(180deg, #8e8e8e 0%, rgba(255, 255, 255, 0) 100%);
    }
}
</style>
